module.exports = __webpack_public_path__ + "static/media/i4c-provider.3eaae568.svg";